<h1 class="container-heading">Package type</h1>

<mat-card>
    <mat-card-content>
        <form [formGroup]="formGroup">
            <div class="flex group">
                <mat-form-field class="third2">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="name" required>
                </mat-form-field>

                <mat-form-field class="third">
                    <mat-label>Weight, kg</mat-label>
                    <input matInput formControlName="weight" type="number" min="0" required>
                </mat-form-field>

                <div class="full">
                    <mat-checkbox formControlName="is_active">Is active</mat-checkbox>
                </div>
            </div>

            <div class="flex group" *ngIf="(formGroup.get('name').value || '').toString().trim().toLowerCase() === 'envelope'">
                <mat-form-field class="third">
                    <mat-label>Length (cm)</mat-label>
                    <input matInput formControlName="length" type="number" min="0">
                </mat-form-field>
                <mat-form-field class="third">
                    <mat-label>Width (cm)</mat-label>
                    <input matInput formControlName="width" type="number" min="0">
                </mat-form-field>
                <mat-form-field class="third">
                    <mat-label>Height (cm)</mat-label>
                    <input matInput formControlName="height" type="number" min="0">
                </mat-form-field>
            </div>

            <div class="actions">
                <button mat-raised-button (click)="submitForm()" color="primary"
                        [disabled]="!formGroup.valid">
                    Save
                </button>
                &nbsp;
                <button mat-raised-button (click)="close()">
                    Close
                </button>
            </div>

        </form>
    </mat-card-content>
</mat-card>
